import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ToolsBoxService} from "../../Services/tools.service";
import { NgClass } from '@angular/common';

@Component({
    selector: 'releaseNote',
    templateUrl: 'releasenote.component.html',
    styleUrls: ['releasenote.component.css'],
    imports: [NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReleaseNoteComponent implements OnInit {

  backEndReleaseNote: string;
  displayFrontRelease= true;
  apiDocAddress: string;

  constructor(private toolsBoxService: ToolsBoxService) {
    this.backEndReleaseNote = this.toolsBoxService.backEndReleaseNote;
    this.apiDocAddress = this.toolsBoxService.getServerAddress().replace('api', 'swagger-ui/index.html   ');
  }

  ngOnInit() {
   this.toolsBoxService.changeHeaderName("Release Note");
  }

}
